import React from 'react';
import ScannerShell from './components/ScannerShell';

const Scanner = () => <ScannerShell inputMode="camera" />;

export default Scanner;
